(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/result-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/result-page.js');

'use strict';

const {
  useEffect
} = React;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  shouldShowIntervalAtom,
  correctionStepAtom,
  showFullscreenAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  DrawPicker,
  Result,
  ResultInterval,
  ParamsFullscreen
} = svs.lyckoplatsen.components.page_result.react.components;
const ResultPage = () => {
  const shouldShowInterval = useAtomValue(shouldShowIntervalAtom);
  const [correctionStep, setCorrectionStep] = useAtom(correctionStepAtom);
  const showFullscreen = useAtomValue(showFullscreenAtom);
  useEffect(() => {
    if (shouldShowInterval) {
      setCorrectionStep(4);
    }
  }, [shouldShowInterval, setCorrectionStep]);
  useEffect(() => {
    if (!svs.core.detect.os.iOS()) {
      return;
    }
    const preventZoom = e => e.preventDefault();
    document.addEventListener('gesturestart', preventZoom);
    return () => {
      document.removeEventListener('gesturestart', preventZoom);
    };
  }, []);
  return React.createElement("div", {
    className: "lp-page-result lp-page-grow lp-correction-step-".concat(correctionStep, " ").concat(correctionStep !== 4 && isSelfService ? 'lp-no-ss-bottom-margin' : '')
  }, showFullscreen && React.createElement(ParamsFullscreen, null), React.createElement(DrawPicker, null), shouldShowInterval ? React.createElement(ResultInterval, null) : React.createElement(Result, null));
};
Object.assign(svs.lyckoplatsen.components.page_result.react, {
  ResultPage
});

 })(window);